import { isHTMLElement } from '../../typeValidators';

/*
  Calibre-converted EPUBs replace semantic paragraph/list markup with generated
  `<div class="calibreN">` elements styled as block or list-item, so class name plus
  computed display is the only way to recognize their paragraphs.
  Note: not all `calibre*` classes are block-level.
*/
const calibreClassPattern = /^calibre\d*$/;

export default function checkIsCalibreBlockLevelElement(node?: Node | null): boolean {
  if (!isHTMLElement(node) || node.tagName.toLowerCase() !== 'div') {
    return false;
  }
  if (!Array.from(node.classList).some((className) => calibreClassPattern.test(className))) {
    return false;
  }
  const { display } = window.getComputedStyle(node);
  return ['block', 'list-item'].includes(display);
}
